import { combineReducers } from 'redux';
import color from './color';

export default combineReducers({
  color
});
